import { render, staticRenderFns } from "./tickertext.vue?vue&type=template&id=43c1d1fe&scoped=true&"
import script from "./tickertext.vue?vue&type=script&lang=js&"
export * from "./tickertext.vue?vue&type=script&lang=js&"
import style0 from "./tickertext.vue?vue&type=style&index=0&id=43c1d1fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c1d1fe",
  null
  
)

export default component.exports